import React from "react";
import StepCompleteActionButton from "./StepCompleteActionButton";

const CitizenDocumentChooser = ({ onSelect }) => {
    return (
        <>
            <h1 className="text-dark mb-4 fw-semibold">Choose your document</h1>

            <StepCompleteActionButton
                label="Passport"
                onClick={() =>
                    onSelect({
                        subPhase: "passport",
                        nextPhase: "camera",
                        reset: true
                    })
                }
            />

            <div className="mt-3" />

            <StepCompleteActionButton
                label="Birth Certificate"
                onClick={() =>
                    onSelect({
                        subPhase: "birth_certificate",
                        nextPhase: "camera",
                        reset: true
                    })
                }
            />
        </>
    );
};

export default CitizenDocumentChooser;